import { epiCycles } from "./epicycles.js";
import { analyse, reconstructPath, setSource, state as page } from "./signal.js";

//Chain colors of the dark drawing board: the dark theme steps of --fx-x and --fx-y.
const X_COLOR = "#e8607c";
const Y_COLOR = "#4a90ec";

export let userSketch = function (pFIVE) {
  const USER = 0;
  const FOURIER = 1;
  //2 states eitehr we are taking user input or we completing a fourier transform.

  let signal = null;
  let time = 0;
  let path = [];
  let pathK = null;
  let drawing = [];
  let state = -1; //To begin width state is negative one i.e. not in user or fft.

  pFIVE.mouseDown = function () {
    state = USER; //Click mouse state user.
    drawing = [];
    time = 0;
  };

  pFIVE.mouseUp = function () {
    if (state !== USER) {
      return;
    }
    if (drawing.length < 3) {
      state = -1; //A click is not a drawing.
      return;
    }
    state = FOURIER; //release mouse state fourier.
    //Points from the centre of the canvas, y pointing up.
    const points = drawing.map((p) => ({ x: p.x - pFIVE.width / 2, y: pFIVE.height / 2 - p.y }));
    signal = analyse("Votre dessin", points);
    pathK = null;
    setSource("drawing", signal);
  };

  pFIVE.setup = function () {
    let cnv = pFIVE.createCanvas(700, 600);
    cnv.parent("draw-yourself");
    cnv.id("userCanvas");
    pFIVE.frameRate(35);
    cnv.mousePressed(pFIVE.mouseDown);
    cnv.touchStarted(pFIVE.mouseDown);
    cnv.mouseReleased(pFIVE.mouseUp);
    cnv.touchEnded(pFIVE.mouseUp);

    document
      .getElementById("userCanvas")
      .addEventListener("touchmove", (evt) => evt.preventDefault(), {
        passive: false,
      });
  };

  pFIVE.draw = function () {
    pFIVE.background(47, 72, 88);
    pFIVE.noFill();

    if (state == USER) {
      drawing.push(pFIVE.createVector(pFIVE.mouseX, pFIVE.mouseY)); //Push point to drawing.
      pFIVE.stroke(255);
      pFIVE.beginShape(); //Render what the user is drawing.
      for (let p of drawing) {
        pFIVE.vertex(p.x, p.y);
      }
      pFIVE.endShape();
    } else if (state == FOURIER) {
      const K = page.K;
      if (K !== pathK) {
        //Path drawn by the K largest terms of each coordinate.
        path = reconstructPath(signal, K, Math.max(2 * signal.numPoints, 400)).map(toCanvas);
        pathK = K;
      }
      //The user's drawing, in grey behind the path traced by the epicycles.
      pFIVE.stroke(125, 140, 150);
      pFIVE.strokeWeight(2);
      pFIVE.beginShape();
      for (let p of drawing) {
        pFIVE.vertex(p.x, p.y);
      }
      pFIVE.endShape();

      const { fourierX, fourierY } = signal;
      let vx = epiCycles(pFIVE, fourierX.terms, K, time, pFIVE.width / 2 + fourierX.mean, 100, 0, X_COLOR);
      let vy = epiCycles(pFIVE, fourierY.terms, K, time, 100, pFIVE.height / 2 - fourierY.mean, -pFIVE.HALF_PI, Y_COLOR);
      let v = pFIVE.createVector(vx.x, vy.y);
      pFIVE.stroke(255, 255, 255, 140);
      pFIVE.line(vx.x, vx.y, v.x, v.y);
      pFIVE.line(vy.x, vy.y, v.x, v.y);

      pFIVE.stroke(255);
      pFIVE.strokeWeight(2);
      pFIVE.beginShape();
      const last = Math.floor((time / pFIVE.TWO_PI) * path.length) + 1;
      for (let i = 0; i < Math.min(last, path.length); i++) {
        pFIVE.vertex(path[i].x, path[i].y);
      }
      pFIVE.vertex(v.x, v.y);
      pFIVE.endShape();
      pFIVE.strokeWeight(1);

      //Replays the drawing at the speed it was drawn.
      const dt = pFIVE.TWO_PI / Math.max(signal.numPoints, 100);
      time += dt;

      if (time > pFIVE.TWO_PI) {
        time = 0;
      }
    }
  };

  function toCanvas(p) {
    return { x: pFIVE.width / 2 + p.x, y: pFIVE.height / 2 - p.y };
  }
};
